import { useContext, useEffect } from "react";
import { ControlContext } from "../../../ControlContext.jsx";

import BoxProfileSegment from "./BoxProfileSegment.jsx";

export default function AluminumProfile({ glassInsert }) {
  const {
    printWidth,
    printHeight,
    borderWidth,
    borderHeight,
    aluminumProfileWidth,
    aluminumProfileDepth,
    profileFrontMaterial,
    profileSideMaterial,
    frameExposure,
    frameToneMapping,
  } = useContext(ControlContext);

  useEffect(() => {
    if (profileFrontMaterial) {
      profileFrontMaterial.toneMapped = true;
      profileFrontMaterial.toneMapping = frameToneMapping;
      profileFrontMaterial.toneMappingExposure = frameExposure;
    }
    if (profileSideMaterial) {
      profileSideMaterial.toneMapped = true;
      profileSideMaterial.toneMapping = frameToneMapping;
      profileSideMaterial.toneMappingExposure = frameExposure;
    }
  }, [profileFrontMaterial, profileSideMaterial, frameToneMapping, frameExposure]);


  const totalWidth = printWidth + 2 * borderWidth;
  const totalHeight = printHeight + 2 * borderHeight;

  const props = {
    profileWidth: aluminumProfileWidth,
    profileDepth: aluminumProfileDepth,
    glassInsert,
    frontMaterial: profileFrontMaterial,
    sideMaterial: profileSideMaterial,
  };

  return (
    <>
      <BoxProfileSegment
        totalWidth={totalWidth}
        totalHeight={totalHeight}
        rotation={0}
        {...props}
      />
      <BoxProfileSegment
        totalWidth={totalWidth}
        totalHeight={totalHeight}
        rotation={Math.PI}
        {...props}
      />
      <BoxProfileSegment
        totalWidth={totalHeight}
        totalHeight={totalWidth}
        rotation={Math.PI / 2}
        {...props}
      />
      <BoxProfileSegment
        totalWidth={totalHeight}
        totalHeight={totalWidth}
        rotation={-Math.PI / 2}
        {...props}
      />
    </>
  );
}
